"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require("../../common/tool");

var _tool2 = _interopRequireDefault(_tool);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _config = require("../../common/config");

var _config2 = _interopRequireDefault(_config);

var _login = require("../login/login");

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var Activity = /** @class */function () {
    function Activity() {
        this.activityDom = document.getElementById('activity');
        this.wmRequest = new _request2.default();
        this.init();
    }
    Activity.prototype.init = function () {
        this.handleBanner();
        this.handlePurchase();
        this.handleTerm();
        this.handleProduct();
        this.handleNotice();
    };
    Activity.prototype.handleBanner = function () {
        this.handleHeader();
        this.handleScrollBar();
    };
    Activity.prototype.handleHeader = function () {
        var that = this;
        var hiddenHeader = _tool2.default.$_select(this.activityDom, '.hidden-header-box');
        var bottomBox = _tool2.default.$_select(this.activityDom, '.bottom-box');
        window.addEventListener('scroll', function () {
            var scrolledTop = Math.ceil(document.documentElement.scrollTop || document.body.scrollTop);
            if (scrolledTop > 60) {
                hiddenHeader.classList.add('show');
                bottomBox.classList.add('show');
            } else {
                hiddenHeader.classList.remove('show');
                bottomBox.classList.remove('show');
            }
        });
        var hasGotoLogin = document.body.contains(document.getElementsByClassName('goto-login')[0]);
        if (hasGotoLogin) {
            var gotoLogin = _tool2.default.$_selectAll(this.activityDom, '.goto-login');
            gotoLogin.forEach(function (item) {
                item.addEventListener('click', function () {
                    new _login2.default();
                });
            });
        }
        var hasGotoLogout = document.body.contains(document.getElementsByClassName('goto-logout')[0]);
        if (hasGotoLogout) {
            // const gotoLogout = Tool.$_select(this.activityDom, '.avatar-box');
            var gotoLogoutAll = _tool2.default.$_selectAll(this.activityDom, '.avatar-box');
            // const logout = Tool.$_select(this.activityDom, '.logout');
            var logoutAll = _tool2.default.$_selectAll(this.activityDom, '.logout');
            gotoLogoutAll.forEach(function (gotoLogout) {
                gotoLogout.addEventListener('mouseenter', function () {
                    var childNode = this.children[1];
                    if (!childNode.classList.contains('show')) {
                        childNode.classList.add('show');
                    } else {
                        childNode.classList.remove('show');
                    }
                });
                gotoLogout.addEventListener('mouseleave', function () {
                    var childNode = this.children[1];
                    if (!childNode.classList.contains('show')) {
                        childNode.classList.add('show');
                    } else {
                        childNode.classList.remove('show');
                    }
                });
            });
            logoutAll.forEach(function (item) {
                item.addEventListener('click', function () {
                    that.wmRequest.ajax({
                        type: 'GET',
                        url: _config2.default.WM_LOGINOUT
                    }).then(function (res) {
                        if (res.code == 200) {
                            window.location.reload();
                        }
                    });
                });
            });
            // logout.addEventListener('click', () => {
            //   that.wmRequest.ajax({
            //     type: 'GET',
            //     url: Config.WM_LOGINOUT
            //   }).then((res: any) => {
            //     if (res.code == 200) {
            //       window.location.reload()
            //     }
            //   })
            // })
        }
    };
    Activity.prototype.handleScrollBar = function () {
        var bannerBuyUls = _tool2.default.$_selectAll(this.activityDom, '.banner-buy-box ul');
        var appendStr = '';
        for (var _i = 0, userJson_1 = userJson; _i < userJson_1.length; _i++) {
            var item = userJson_1[_i];
            appendStr += "<li>\n                <img src=\"".concat(item.img, "\" alt=\"\">\n                <p>").concat(item.name, "\u521A\u521A\u8D2D\u4E70\u4E86</p>\n              </li>");
        }
        bannerBuyUls.forEach(function (item) {
            item.insertAdjacentHTML('beforeend', appendStr);
        });
    };
    Activity.prototype.handlePurchase = function () {
        var _this = this;
        var timerObj = this.changeTimeFormat();
        if (user_data.member_status == 6 || timerObj.currentTime < timerObj.startTime || timerObj.currentTime > timerObj.endTime) {
            return;
        }
        // 填写原价、支付金额、优惠金额
        var originalPrice = 0;
        var actualPay = 0;
        var discountPrice = 0;
        var bucket;
        for (var _i = 0, packageList_1 = packageList; _i < packageList_1.length; _i++) {
            // 获取个人永久全家桶套餐包
            var item = packageList_1[_i];
            // attribute:个人 time_out:永久 type:全家桶
            if (item.attribute == 1 && item.time_out == -1 && item.type == 3) {
                bucket = item;
                break;
            }
        }
        originalPrice = bucket.g_price;
        var actualPayDom = _tool2.default.$_select(this.activityDom, '.actual-pay');
        // const originalPriceDom = Tool.$_select(this.activityDom, '.original-price')
        var discountPriceDom = _tool2.default.$_select(this.activityDom, '.discount-price');
        if (couponList.length == 0) {
            // 未领取优惠券
            actualPay = originalPrice;
        } else {
            // 已领取优惠券
            discountPrice = couponList[0].coupon_money;
            actualPay = originalPrice - discountPrice < 0 ? 1 : originalPrice - discountPrice;
        }
        // originalPriceDom.innerHTML = String(originalPrice)
        actualPayDom.innerHTML = String(actualPay);
        discountPriceDom.innerHTML = String(discountPrice);
        // 支付
        if (userLogin == 1) {
            var refreshDom_1 = _tool2.default.$_select(this.activityDom, '.refresh-qrcode'); // 点击刷新
            var qrcodeImgDom_1 = _tool2.default.$_select(this.activityDom, '#qrcode-img'); // 二维码盒子
            // 请求支付二维码
            var tmpData = {};
            if (couponList.length != 0) {
                tmpData = {
                    coupon_id: couponList[0].coupon_id,
                    coupon_money: couponList[0].coupon_money * 100
                };
            }
            var data_1 = __assign(__assign({}, tmpData), payParams);
            this.handlePay(data_1, refreshDom_1, qrcodeImgDom_1);
            refreshDom_1.addEventListener('click', function () {
                refreshDom_1.classList.remove('show');
                _this.handlePay(data_1, refreshDom_1, qrcodeImgDom_1);
            });
        }
    };
    Activity.prototype.handlePay = function (data, refreshDom, qrcodeImgDom) {
        return __awaiter(this, void 0, void 0, function () {
            var flag, o_id, pollingTimer_1, countTimer_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flag = false;
                        return [4 /*yield*/, this.wmRequest.ajax({
                            url: _config2.default.WM_ACTIVITYGETQRCODE,
                            type: 'POST',
                            data: data
                        }).then(function (res) {
                            if (res.code == 200) {
                                o_id = res.out_trade_no;
                                var qrcodeImgUrl = res.url;
                                createQrcode(qrcodeImgDom, qrcodeImgUrl);
                                flag = true;
                            } else {
                                alert('支付二维码生成失败，请联系客服！');
                            }
                        }).catch(function (err) {
                            console.log(err);
                        })
                        // 轮询
                        ];
                    case 1:
                        _a.sent();
                        // 轮询
                        if (flag) {
                            pollingTimer_1 = setInterval(function () {
                                _this.wmRequest.ajax({
                                    url: _config2.default.WM_ACTIVITYPOLLING,
                                    data: {
                                        o_id: o_id
                                    },
                                    type: 'POST'
                                }).then(function (res) {
                                    if (res.code == 200) {
                                        clearInterval(pollingTimer_1);
                                        // 显示购买成功弹窗
                                        // 清空二维码，显示点击刷新
                                        qrcodeImgDom.innerHTML = '';
                                        refreshDom.classList.add('show');
                                        var successBox = _tool2.default.$_select(_this.activityDom, '.success-box');
                                        successBox.classList.add('show');
                                        successBox.addEventListener('click', function () {
                                            window.location.reload();
                                        });
                                    } else if (res.code == 209) {
                                        // console.log('等待支付') 
                                    } else {
                                        clearInterval(pollingTimer_1);
                                        alert('支付失败，请联系客服！');
                                    }
                                }).catch(function (err) {
                                    console.log(err);
                                });
                            }, 2000);
                            countTimer_1 = setTimeout(function () {
                                clearInterval(pollingTimer_1);
                                clearTimeout(countTimer_1);
                                // 清空二维码，显示点击刷新
                                qrcodeImgDom.innerHTML = '';
                                refreshDom.classList.add('show');
                            }, 120000);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Activity.prototype.handleTerm = function () {
        var termDom = _tool2.default.$_select(this.activityDom, '.term-box');
        var purchaseTerm = _tool2.default.$_select(this.activityDom, '.purchase-term');
        purchaseTerm.addEventListener('click', function () {
            termDom.classList.add('show');
        });
        var gotoPurchase = _tool2.default.$_select(this.activityDom, '.term-goto-purchase');
        gotoPurchase.addEventListener('click', function () {
            termDom.classList.remove('show');
        });
        termDom.addEventListener('click', function () {
            termDom.classList.remove('show');
        });
    };
    Activity.prototype.handleProduct = function () {
        var _this = this;
        var firstTab = _tool2.default.$_select(this.activityDom, '.product-container ul li:first-child');
        firstTab.classList.add('active');
        var firstProductContent = _tool2.default.$_select(this.activityDom, '.product-wrapper .product-content:first-child');
        firstProductContent.classList.add('show');
        var tabs = _tool2.default.$_selectAll(this.activityDom, '.product-container ul li');
        tabs.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                tabs.forEach(function (tItem) {
                    return tItem.classList.remove('active');
                });
                item.classList.add('active');
                var dataAlias = item.getAttribute('data-alias');
                var productContents = _tool2.default.$_selectAll(_this.activityDom, '.product-content');
                productContents.forEach(function (pItem) {
                    return pItem.classList.remove('show');
                });
                var productContent = _tool2.default.$_select(_this.activityDom, ".".concat(dataAlias));
                productContent.classList.add('show');
            });
        });
    };
    Activity.prototype.changeTimeFormat = function () {
        var currentTime = new Date().getTime();
        var startTime = new Date(start_time.replace(/-/g, '/')).getTime();
        var endTime = new Date(end_time.replace(/-/g, '/')).getTime();
        var timerObj = {
            currentTime: currentTime,
            startTime: startTime,
            endTime: endTime
        };
        return timerObj;
    };
    Activity.prototype.handleNotice = function () {
        var timerObj = this.changeTimeFormat();
        var noticeDom = _tool2.default.$_select(this.activityDom, '.notice-box');
        var flag = true;
        if (timerObj.startTime > timerObj.currentTime) {
            // 活动未开始
            var noStartNotice = _tool2.default.$_select(this.activityDom, '.activity-no-start');
            noticeDom.classList.add('show');
            noStartNotice.classList.add('show');
            flag = false;
        }
        if (timerObj.endTime < timerObj.currentTime) {
            // 活动已结束
            var endNotice = _tool2.default.$_select(this.activityDom, '.activity-end');
            noticeDom.classList.add('show');
            endNotice.classList.add('show');
            flag = false;
        }
        if (flag && user_data.member_status == 6) {
            var shareNotice = _tool2.default.$_select(this.activityDom, '.share-box');
            noticeDom.classList.add('show');
            shareNotice.classList.add('show');
        }
        var tips = document.querySelector('.tips');
        if (couponList.length != 0 && timerObj.currentTime >= timerObj.startTime && timerObj.currentTime <= timerObj.endTime) {
            tips.innerHTML = '成功领取优惠券';
            tips.classList.add('show');
            var timer_1 = setTimeout(function () {
                tips.classList.remove('show');
                clearTimeout(timer_1);
            }, 3000);
        }
        var share = _tool2.default.$_select(this.activityDom, '.share');
        share.addEventListener('click', function () {
            var copyVal = document.querySelector('.copy-url');
            if (navigator.clipboard) {
                navigator.clipboard.writeText(copyVal.innerText);
            } else {
                var eventCopyer = function eventCopyer(event) {
                    event.preventDefault();
                    event.clipboardData.setData("text/plain", copyVal.innerText);
                };
                document.addEventListener("copy", eventCopyer);
                document.execCommand("copy");
                document.removeEventListener("copy", eventCopyer);
            }
            tips.innerHTML = '已复制链接至剪切板';
            tips.classList.add('show');
            var timer = setTimeout(function () {
                tips.classList.remove('show');
                clearTimeout(timer);
            }, 3000);
        });
    };
    return Activity;
}();
exports.default = Activity;